import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getRoleListSuccess(role) {
  return {type: types.LOAD_ROLE_LIST_SUCCESS, role};
}



export function getRoleList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RoleApi.getRoleList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(role => {                  
                  dispatch(getRoleListSuccess(role));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getRoleSuccess(catalogo) {
  return {type: types.LOAD_ROLE_SUCCESS, catalogo};
}

export function getRole(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().RoleApi.getRole(id, token).then(role => {   
        dispatch(getRoleSuccess(role));
        return role;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(role) {
  return {type: types.SAVE_ROLE_SUCCESS, role};
}


export function save(role, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().RoleApi.save(role, token).then(roleGuardado => {   
    dispatch(saveSuccess(roleGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getRoleComboSuccess(datos) {
  return {type: types.GET_ROLES_COMBO_SUCCESS, datos};
}

export function getRoleCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().RoleApi.getRoleCombo(token).then(datos => {   
        
      dispatch(getRoleComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(role) {
  return {type: types.BORRAR_ROLE_SUCCESS, role};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RoleApi.borrar(id, token ).then(role => {
               
                  dispatch(borrarSuccess(role));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(role) {
  return {type: types.ACTIVAR_ROLE_SUCCESS, role};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RoleApi.activar(id, token).then(role => {
               
                  dispatch(activarSuccess(role));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_ROLE, filtro};
}



